const initialState = {
    isRunPythoncode: false,
    tmpCodeText: '',
    tmpLogText: ''
};

const SET_IS_RUN_PYTHONCODE = 'scratch-gui/pythoncode/SET_IS_RUN_PYTHONCODE';
const UPDATE_TMP_CODE_TEXT = 'scratch-gui/pythoncode/UPDATE_TMP_CODE_TEXT';
const UPDATE_TMP_LOG_TEXT = 'scratch-gui/pythoncode/UPDATE_TMP_LOG_TEXT';

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case UPDATE_TMP_CODE_TEXT:
        return Object.assign({}, state, {
            tmpCodeText: action.tmpCodeText
        });
    case UPDATE_TMP_LOG_TEXT:
        return Object.assign({}, state, {
            tmpLogText: action.tmpLogText
        });
    case SET_IS_RUN_PYTHONCODE:
        return Object.assign({}, state, {
            isRunPythoncode: action.isRun
        });
    default:
        return state;
    }
};

const setIsRunPythoncode = function (isRun) {
    return {
        type: SET_IS_RUN_PYTHONCODE,
        isRun: isRun ?? false
    };
};

const updateTmpCodeText = function (tmpCodeText) {
    return {
        type: UPDATE_TMP_CODE_TEXT,
        tmpCodeText: tmpCodeText
    };
};

const updateTmpLogText = function (tmpLogText) {
    return {
        type: UPDATE_TMP_LOG_TEXT,
        tmpLogText: tmpLogText
    };
};


export {
    reducer as default,
    initialState as pythoncodeInitialState,
    setIsRunPythoncode,
    updateTmpCodeText,
    updateTmpLogText
};
